module.exports = __webpack_public_path__ + "media/images/special-reports-317f81a4a622726724536edb91d62afd.png";